<template>

  <b-row class="my-5 col-lg-12" align-h="center">

    <b-row class="my-5 col-lg-12" align-h="center"
           v-for="menu in storeMenus" :key="menu.id" v-if="menu.position==='store_footer'">
      <b-col class="text-center " lg="12"
             v-for="item in menu.children" :key="item.id" v-if="menu.children.length!==0">

        <a class="text-center  btn" :href="item.url">
          <span class="font-weight-bold text-center">{{ item.name }}</span>
          <m-icon class="mr-2" :icon="item.icon_class" />
        </a>

      </b-col>
    </b-row>

  </b-row>

</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "MainFooterMenu",
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getStoreMenus"
    })
  },
  mounted() {
    this.$store.dispatch("Menu/getStoreMenus");

  }
}
</script>

<style scoped>

</style>